// SPDX-License-Identifier: GPL-3.0-or-later
// GENERATED by scripts/import-palettes.ts — do not edit by hand.
//
// Thread charts converted from the Ink/Stitch GIMP palettes (palettes/*.gpl),
// https://github.com/inkstitch/inkstitch/tree/d59c9ab1e390285a6c67822436ffd9ba9843d8b4/palettes
// Ink/Stitch commit: d59c9ab1e390285a6c67822436ffd9ba9843d8b4
// Copyright (C) the Ink/Stitch authors. Licensed under GPL-3.0-or-later.

export const INKSTITCH_COMMIT = 'd59c9ab1e390285a6c67822436ffd9ba9843d8b4';

export interface ChartManifestEntry {
  id: string;
  name: string;
  brand: string;
  count: number;
  /** Source palette file in Ink/Stitch. */
  source: string;
}

export const CHART_MANIFEST: readonly ChartManifestEntry[] = [
  {
    id: 'admelody-polyester',
    name: 'Admelody Polyester',
    brand: 'Admelody',
    count: 320,
    source: 'InkStitch Admelody Polyester.gpl',
  },
  {
    id: 'admelody-rayon',
    name: 'Admelody Rayon',
    brand: 'Admelody',
    count: 420,
    source: 'InkStitch Admelody Rayon.gpl',
  },
  { id: 'anchor', name: 'Anchor', brand: 'Anchor', count: 423, source: 'InkStitch Anchor.gpl' },
  {
    id: 'arc-polyester',
    name: 'ARC Polyester',
    brand: 'ARC',
    count: 288,
    source: 'InkStitch ARC Polyester.gpl',
  },
  { id: 'arc-rayon', name: 'ARC Rayon', brand: 'ARC', count: 288, source: 'InkStitch ARC Rayon.gpl' },
  {
    id: 'aurifil-lana',
    name: 'Aurifil Lana',
    brand: 'Aurifil',
    count: 106,
    source: 'InkStitch Aurifil Lana.gpl',
  },
  {
    id: 'aurifil-mako',
    name: 'Aurifil Mako',
    brand: 'Aurifil',
    count: 158,
    source: 'InkStitch Aurifil Mako.gpl',
  },
  {
    id: 'aurifil-polyester',
    name: 'Aurifil Polyester',
    brand: 'Aurifil',
    count: 204,
    source: 'InkStitch Aurifil Polyester.gpl',
  },
  {
    id: 'aurifil-rayon',
    name: 'Aurifil Rayon',
    brand: 'Aurifil',
    count: 180,
    source: 'InkStitch Aurifil Rayon.gpl',
  },
  {
    id: 'aurifil-royal',
    name: 'Aurifil Royal',
    brand: 'Aurifil',
    count: 499,
    source: 'InkStitch Aurifil Royal.gpl',
  },
  {
    id: 'bfc-polyester',
    name: 'BFC Polyester',
    brand: 'BFC',
    count: 320,
    source: 'InkStitch BFC Polyester.gpl',
  },
  { id: 'brildor-ac', name: 'Brildor AC', brand: 'Brildor', count: 120, source: 'InkStitch Brildor AC.gpl' },
  { id: 'brildor-co', name: 'Brildor CO', brand: 'Brildor', count: 70, source: 'InkStitch Brildor CO.gpl' },
  { id: 'brildor-mf', name: 'Brildor MF', brand: 'Brildor', count: 210, source: 'InkStitch Brildor MF.gpl' },
  { id: 'brildor-ny', name: 'Brildor NY', brand: 'Brildor', count: 180, source: 'InkStitch Brildor NY.gpl' },
  { id: 'brildor-pb', name: 'Brildor PB', brand: 'Brildor', count: 260, source: 'InkStitch Brildor PB.gpl' },
  {
    id: 'brother-country',
    name: 'Brother Country',
    brand: 'Brother',
    count: 61,
    source: 'InkStitch Brother Country.gpl',
  },
  {
    id: 'brother-embroidery',
    name: 'Brother Embroidery',
    brand: 'Brother',
    count: 61,
    source: 'InkStitch Brother Embroidery.gpl',
  },
  {
    id: 'brothread-40',
    name: 'New Brothread 40 Colors',
    brand: 'Brothread',
    count: 40,
    source: 'InkStitch Brothread 40.gpl',
  },
  {
    id: 'brothread-80',
    name: 'New Brothread 80 Colors',
    brand: 'Brothread',
    count: 78,
    source: 'InkStitch Brothread 80.gpl',
  },
  {
    id: 'coats-alcazar',
    name: 'Coats Alcazar',
    brand: 'Coats',
    count: 500,
    source: 'InkStitch Coats Alcazar.gpl',
  },
  {
    id: 'coats-alcazar-jazz',
    name: 'Coats Alcazar Jazz',
    brand: 'Coats',
    count: 304,
    source: 'InkStitch Coats Alcazar Jazz.gpl',
  },
  { id: 'coats-sylko', name: 'Coats Sylko', brand: 'Coats', count: 399, source: 'InkStitch Coats Sylko.gpl' },
  {
    id: 'coats-sylko-usa',
    name: 'Coats Sylko USA',
    brand: 'Coats',
    count: 303,
    source: 'InkStitch Coats Sylko USA.gpl',
  },
  { id: 'dmc', name: 'DMC', brand: 'DMC', count: 458, source: 'InkStitch DMC.gpl' },
  { id: 'embroidex', name: 'Embroidex', brand: 'Embroidex', count: 258, source: 'InkStitch Embroidex.gpl' },
  { id: 'emmel', name: 'Emmel', brand: 'Emmel', count: 521, source: 'InkStitch Emmel.gpl' },
  {
    id: 'fil-tec-glide',
    name: 'Fil-Tec Glide',
    brand: 'Fil-Tec',
    count: 212,
    source: 'InkStitch Fil-Tec Glide.gpl',
  },
  {
    id: 'floriani-polyester',
    name: 'Floriani Polyester',
    brand: 'Floriani',
    count: 286,
    source: 'InkStitch Floriani Polyester.gpl',
  },
  {
    id: 'fufu-polyester',
    name: 'FuFu Polyester',
    brand: 'FuFu',
    count: 713,
    source: 'InkStitch FuFu Polyester.gpl',
  },
  { id: 'fufu-rayon', name: 'FuFu Rayon', brand: 'FuFu', count: 713, source: 'InkStitch FuFu Rayon.gpl' },
  {
    id: 'gunold-polyester',
    name: 'Gunold Polyester',
    brand: 'Gunold',
    count: 300,
    source: 'InkStitch Gunold Polyester.gpl',
  },
  {
    id: 'gutermann-creativ-dekor',
    name: 'Gutermann Creativ Dekor',
    brand: 'Gütermann',
    count: 200,
    source: 'InkStitch Gutermann Creativ Dekor.gpl',
  },
  {
    id: 'hemingworth',
    name: 'Hemingworth',
    brand: 'Hemingworth',
    count: 294,
    source: 'InkStitch Hemingworth.gpl',
  },
  {
    id: 'viking-palette',
    name: 'Viking Palette',
    brand: 'Husqvarna Viking',
    count: 29,
    source: 'InkStitch Viking Palette.gpl',
  },
  {
    id: 'isacord-polyester',
    name: 'Isacord Polyester',
    brand: 'Isacord',
    count: 398,
    source: 'InkStitch Isacord Polyester.gpl',
  },
  {
    id: 'isafil-rayon',
    name: 'Isafil Rayon',
    brand: 'Isafil',
    count: 286,
    source: 'InkStitch Isafil Rayon.gpl',
  },
  {
    id: 'isalon-polyester',
    name: 'Isalon Polyester',
    brand: 'Isalon',
    count: 414,
    source: 'InkStitch Isalon Polyester.gpl',
  },
  { id: 'janome', name: 'Janome', brand: 'Janome', count: 78, source: 'InkStitch Janome.gpl' },
  { id: 'king-star', name: 'King Star', brand: 'King Star', count: 430, source: 'InkStitch King Star.gpl' },
  {
    id: 'madeira-burmilana',
    name: 'Madeira Burmilana',
    brand: 'Madeira',
    count: 121,
    source: 'InkStitch Madeira Burmilana.gpl',
  },
  {
    id: 'madeira-matt',
    name: 'Madeira Matt',
    brand: 'Madeira',
    count: 161,
    source: 'InkStitch Madeira Matt.gpl',
  },
  {
    id: 'madeira-polyneon',
    name: 'Madeira Polyneon',
    brand: 'Madeira',
    count: 349,
    source: 'InkStitch Madeira Polyneon.gpl',
  },
  {
    id: 'madeira-rayon',
    name: 'Madeira Rayon',
    brand: 'Madeira',
    count: 357,
    source: 'InkStitch Madeira Rayon.gpl',
  },
  { id: 'magnifico', name: 'Magnifico', brand: 'Magnifico', count: 200, source: 'InkStitch Magnifico.gpl' },
  {
    id: 'marathon-polyester',
    name: 'Marathon Polyester',
    brand: 'Marathon',
    count: 301,
    source: 'InkStitch Marathon Polyester.gpl',
  },
  {
    id: 'marathon-rayon',
    name: 'Marathon Rayon',
    brand: 'Marathon',
    count: 317,
    source: 'InkStitch Marathon Rayon.gpl',
  },
  {
    id: 'marathon-rayon-v3',
    name: 'Marathon Rayon V3',
    brand: 'Marathon',
    count: 384,
    source: 'InkStitch Marathon Rayon V3.gpl',
  },
  { id: 'metro', name: 'Metro', brand: 'Metro', count: 168, source: 'InkStitch Metro.gpl' },
  {
    id: 'mettler-embroidery',
    name: 'Mettler Embroidery',
    brand: 'Mettler',
    count: 152,
    source: 'InkStitch Mettler Embroidery.gpl',
  },
  {
    id: 'mettler-poly-sheen',
    name: 'Mettler Poly Sheen',
    brand: 'Mettler',
    count: 351,
    source: 'InkStitch Mettler Poly Sheen.gpl',
  },
  {
    id: 'mtb-embroidex',
    name: 'MTB - Embroidex',
    brand: 'MTB',
    count: 107,
    source: 'InkStitch MTB - Embroidex.gpl',
  },
  {
    id: 'outback-embroidery-rayon',
    name: 'Outback Embroidery Rayon',
    brand: 'Outback',
    count: 100,
    source: 'InkStitch Outback Embroidery Rayon.gpl',
  },
  { id: 'poly-x40', name: 'Poly X40', brand: 'Poly X40', count: 286, source: 'InkStitch Poly X40.gpl' },
  { id: 'princess', name: 'Princess', brand: 'Princess', count: 120, source: 'InkStitch Princess.gpl' },
  {
    id: 'radiant-rayon',
    name: 'Radiant Rayon',
    brand: 'Radiant',
    count: 102,
    source: 'InkStitch Radiant Rayon.gpl',
  },
  {
    id: 'robison-anton-polyester',
    name: 'Robison-Anton Polyester',
    brand: 'Robison-Anton',
    count: 447,
    source: 'InkStitch Robison-Anton Polyester.gpl',
  },
  {
    id: 'robison-anton-rayon',
    name: 'Robison-Anton Rayon',
    brand: 'Robison-Anton',
    count: 419,
    source: 'InkStitch Robison-Anton Rayon.gpl',
  },
  {
    id: 'royal-polyester',
    name: 'Royal Polyester',
    brand: 'Royal',
    count: 473,
    source: 'InkStitch Royal Polyester.gpl',
  },
  {
    id: 'royal-viscose-rayon',
    name: 'Royal Viscose Rayon',
    brand: 'Royal',
    count: 494,
    source: 'InkStitch Royal Viscose Rayon.gpl',
  },
  { id: 'sigma', name: 'Sigma', brand: 'Sigma', count: 150, source: 'InkStitch Sigma.gpl' },
  {
    id: 'simthread-polyester-63-brother-colors',
    name: 'Simthread 63 Brother Colours Polyester',
    brand: 'Simthread',
    count: 63,
    source: 'InkStitch Simthread Polyester 63 Brother Colors.gpl',
  },
  {
    id: 'simthread-glow-in-the-dark-15-colors',
    name: 'Simthread glow in the dark 15 colors',
    brand: 'Simthread',
    count: 15,
    source: 'InkStitch Simthread Glow In The Dark 15 Colors.gpl',
  },
  {
    id: 'simthread-polyester',
    name: 'Simthread Polyester',
    brand: 'Simthread',
    count: 107,
    source: 'InkStitch Simthread Polyester.gpl',
  },
  {
    id: 'simthread-rayon',
    name: 'Simthread Rayon',
    brand: 'Simthread',
    count: 384,
    source: 'InkStitch Simthread Rayon.gpl',
  },
  {
    id: 'sulky-polyester',
    name: 'Sulky Polyester',
    brand: 'Sulky',
    count: 907,
    source: 'InkStitch Sulky Polyester.gpl',
  },
  { id: 'sulky-rayon', name: 'Sulky Rayon', brand: 'Sulky', count: 289, source: 'InkStitch Sulky Rayon.gpl' },
  { id: 'swist-rayon', name: 'Swist Rayon', brand: 'Swist', count: 227, source: 'InkStitch Swist Rayon.gpl' },
  { id: 'threadart', name: 'Threadart', brand: 'Threadart', count: 223, source: 'InkStitch Threadart.gpl' },
  {
    id: 'tristar-polyester',
    name: 'Tristar Polyester',
    brand: 'Tristar',
    count: 298,
    source: 'InkStitch Tristar Polyester.gpl',
  },
  {
    id: 'tristar-rayon',
    name: 'Tristar Rayon',
    brand: 'Tristar',
    count: 406,
    source: 'InkStitch Tristar Rayon.gpl',
  },
  {
    id: 'vyapar-rayon',
    name: 'Vyapar Rayon',
    brand: 'Vyapar',
    count: 288,
    source: 'InkStitch Vyapar Rayon.gpl',
  },
  {
    id: 'wonderfil-polyester',
    name: 'Wonderfil Polyester',
    brand: 'Wonderfil',
    count: 170,
    source: 'InkStitch Wonderfil Polyester.gpl',
  },
  {
    id: 'wonderfil-rayon',
    name: 'Wonderfil Rayon',
    brand: 'Wonderfil',
    count: 342,
    source: 'InkStitch Wonderfil Rayon.gpl',
  },
];
